import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewEncapsulation, HostListener } from '@angular/core';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { EmitterService } from '../../services/emitter.service';
import { Utility } from '../../shared/utility/utility';
import { sortState } from '../../shared/utility/config';
import { GameWindowService } from '../../services/gameWindow.services';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import * as _ from 'underscore';
import { GamingUtility } from '../../gaming/gaming.utility';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { UserDetailsService } from '../../services/user-details.service';

@Component({
  selector: 'app-slot-games-search',
  templateUrl: './slot-games-search.component.html',
  styleUrls: ['./slot-games-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SlotGamesSearchComponent implements OnInit, OnDestroy {
  selectedGames;
  searchInput;
  userLogin;
  imgClick;
  langCode;
  totalSearchedGames;
  searchResultsDefaultSize = 6;
  loadMoreSearchGames = this.searchResultsDefaultSize;
  gameUrlPath: string = environment.gamePath;
  siteUrlPath: string = environment.siteUrl;
  mediaUrlPath = environment.koiMediaPath;
  allslotGames;
  showDropdownFilter = false;
  providerResult = '';
  providerResultLength;
  showVendorSearchResults = false;
  providerCode = '';
  windowType;
  closeSearchPos = 9;
  gameProviderMap: Map<string, string> = new Map<string, string>();
  @Input() page;
  @Input() sticky;
  @Output() closeSearchEmit = new EventEmitter();
  @Output() getSlotGames = new EventEmitter();
  destroy$: Subject<boolean> = new Subject<boolean>();
  isHomePage: boolean;
  isPromotionPage: boolean;
  recentlyPlayedGames=[];
  @HostListener('window:resize') onResize() {
    this.deviceType()
  }

  constructor(
    private emitter: EmitterService,
    private utils: Utility,
    private gmService: GameWindowService,
    private router: Router,
    private gamingUtils: GamingUtility,
    public userService: UserDetailsService
  ) {
    this.emitter.loadHomeBanner$.pipe(takeUntil(this.destroy$)).subscribe(message => {
        this.userLogin = this.utils.isUserLoggedIn();
      }
    );

    this.langCode = localStorage.getItem('langCode')
    this.emitter.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });

    this.emitter.showSearchBar$.subscribe((status) => {
      if(!status) {
        this.closeSearchInput();
      }
    });
    this.isHomePage = this.utils.getIsHomePage();

  }

  ngOnInit() {
    this.deviceType();
    this.userLogin = this.utils.isUserLoggedIn();
    this.emitter.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.userLogin = status;
    });

    if (this.gmService.getAllSlotData() && this.gmService.getAllSlotData().length > 0) {
      this.initGamesData();
    } else if (!this.allslotGames) {
      this.gmService.getAllCasinoGames().pipe(takeUntil(this.destroy$)).subscribe(sortedGameData => {
        this.initGamesData(sortedGameData);
      });
    }
    if(this.router.url.includes("promotions")){
      this.isPromotionPage = true; 
    }
   
  }

   async initGamesData(sortedGameData?) {
    this.allslotGames = sortedGameData ? sortedGameData : this.gmService.getAllSlotData();
    this.getSlotGames.emit(this.allslotGames);
    this.gameProviderMap = this.gamingUtils.aggregateGameProvider(this.allslotGames, true);
    if(this.userLogin){
      this.recentlyPlayedGames = await this.gmService.getRecentlyPlayedGamesList();
    }
  }

  toggleDropdownFilter(event?) {
    //this.closeSearch();
    if (event) {
      //this.closeSearchEmit.emit(false);
      this.showDropdownFilter = false;
    } else {
      this.showDropdownFilter = !this.showDropdownFilter;
    }
  }

  searchGames(searchValue, category?): any {
    let searchValLength = searchValue.length * 9;
    let inputWrapWidth = $(".slot-game_search--inputwrap").width() - 45;
    if (searchValLength < inputWrapWidth) {
      this.closeSearchPos = searchValue.length * 9;
    }

    this.showDropdownFilter = false;
    this.loadMoreSearchGames = this.searchResultsDefaultSize;
    this.selectedGames = null;
    if (searchValue === "") {
      this.addRemoveSearchActiveClass(false);
      return;
    }
    this.addRemoveSearchActiveClass(true);
    let slotsGamesLastIndex = this.allslotGames.length-1;
    this.showVendorSearchResults = false;
    if (this.allslotGames !== null && this.allslotGames.length > 0) {
      let vendors = _.groupBy(this.allslotGames, 'vendorDisplayName');
      this.totalSearchedGames = this.allslotGames.filter((game,ind) => {
        if (
          //  game['vendorDisplayName'].toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
          //  && vendors[game['vendorDisplayName']]
          //&&
          ( game["name"].toLowerCase().indexOf(searchValue.toLowerCase()) !== -1 ||
            game["vendorDisplayName"].toLowerCase().indexOf(searchValue.toLowerCase()) != -1)
            && !this.showVendorSearchResults
        ) {
          this.updateProviedersSearchData(vendors, game);
        } else if (
          slotsGamesLastIndex == ind &&
          !this.showVendorSearchResults
        ) {
          this.updateProviedersSearchData(vendors, game);
        }

        return game['name'].toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
               || game['vendorDisplayName'].toLowerCase().indexOf(searchValue.toLowerCase()) != -1;
      });
      this.selectedGames = this.totalSearchedGames.slice(0, this.searchResultsDefaultSize);
    } else {
      this.selectedGames = [];
    }
  }
  enableSearch(){
    $("#searchgames #searchInput").focus();
  }


  loadMoreSearchResult(event) {
    if (event.srcElement.classList && event.srcElement.classList.contains('search_results--lists')) {
      if ($('.search_results--lists').scrollTop() + $('.search_results--lists').innerHeight() 
          >= $('.search_results--lists')[0].scrollHeight-100) {
        this.loadMoreSearchGames += this.searchResultsDefaultSize;
        this.selectedGames = this.totalSearchedGames.slice(0, this.loadMoreSearchGames);
      }
    }
  }

  closeSearch(): void { 
    this.emitter.broadCastShowSearchBar(false);  
    this.closeSearchInput()
  }
  closeSearchInput(){
    this.selectedGames = null;
    this.searchInput = "";
    $("#searchInputLabel").removeClass("active");
    $("#searchInput").parent().parent().removeClass("search-input-active");
  }

  gameLauncher(gameType, gameId, gameLaunchUrlPath): void {
    this.userService.gamePlayLaunchChecks(gameId, gameLaunchUrlPath);
  }

  imgClicked(game, category?) {
    this.gamingUtils.setGameDetails(game);
    this.imgClick = true;
    this.utils.openModal('searchResultsGameModal');
    let buttonId = 'slotsplayBtn';
    if (this.utils.isUserLoggedIn()) {
      this.utils.enableButton(buttonId, "Play");
    } else {
      this.utils.enableButton(buttonId, "Play for free");
    }
  }

  navigateToGames(game) {
    this.emitter.broadcastRouteChange(false);
    this.utils.disablescrollOnRegistrationPageOpend();
    if(this.windowType === 'desktop') {
      /* ND-439 multilingual game launch changes can be modified here */
      this.gameLauncher('realgames', game.gameCode, game['multilingualUrl']['en']);
    } else {
      if (this.utils.isUserLoggedIn()) {
        /* ND-439 multilingual game launch changes can be modified here */
        this.gameLauncher('realgames', game.gameCode, game['multilingualUrl']['en']);
      } else {
        this.closeSearch();
        this.emitter.broadCastIsGameModal(true);
        this.gamingUtils.setGameDetails(game);
      }
      this.emitter.broadCastShowSearchBar(false);
    }
  }

  navigateToVendorGames(vendorName) {
    this.emitter.broadcastRouteChange(false);
    this.utils.disablescrollOnRegistrationPageOpend();
    this.closeSearch();
    this.closeSearchEmit.emit(false);
    this.router.navigate([this.langCode + '/casino/allgames'], 
    { queryParams: { "providerId": vendorName}})
  }
  navigateTo() {
    this.router.navigate([this.langCode + '/login']);
  }

  deviceType() {
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }

  updateProviedersSearchData(vendors,game){
    this.showVendorSearchResults = true;
    this.providerCode = game['vendorCode'];
    this.providerResult = game['vendorDisplayName'];
    this.providerResultLength = vendors[game['vendorDisplayName']].length;
  }
  
  closeSearchBar() {
    this.emitter.broadCastShowSearchBar(false);
    this.searchInput = "";
  }

  addRemoveSearchActiveClass(add){
    if(add){
      $("#searchInput").parent().parent().addClass("search-input-active");
    } else {
      $("#searchInput").parent().parent().removeClass("search-input-active");
    }
  }  
  getSearchInputVal(){
   if(this.searchInput){
    return 'search-key';
   }
   return ''
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}